import { useState } from "react";
import useFetch from "./useFetch";
import { useParams } from "react-router-dom";
import audioicon from "./otherImg/audiomsgsimg.jpg";
import { CircularProgress } from "@mui/material";
import AudioListContent from "./newComponents/AudioListContent";
import hbricon from "./otherImg/hrmwlitelogo.png";

const PlayAudioMessage = () => {
    const {id} = useParams();
    const [searchAudio,setSearchAudio]=useState("");
    const [showMore,setShowmore]=useState("");
    const [showSearch,setShowSearch]=useState(false);
    const {data: selectedAudio,ispending,erroralert} = useFetch(`${process.env.REACT_APP_AUDIO_MESSAGE_URL}/audioMessage/${id}`);
    const {data:horemowaudiomessages,ispending2,erroralert2} = useFetch(`${process.env.REACT_APP_AUDIO_MESSAGE_URL}/audioMessage`);

    const shareAudio=async()=>{
        if(navigator.share && selectedAudio){
            try{
                await navigator.share({
                    title: `${selectedAudio.title}`,
                    text: `Listen to this audio message and your life will never be the same. Very inspiring and crucial for our eternal life.`,
                    url: `https://horemowbookreaderlite.web.app/hrmwaudiomessage/${selectedAudio.title}/${selectedAudio.id}`,
                });
            }catch{
                
            }
        }
    };

    const convertUrl=(urlfromdb)=> {
        const oldFormatRegex = /id=([^&]+)/;
        const match = urlfromdb.match(oldFormatRegex);
        const audioid = match ? match[1] : null;
      
        if (audioid) {
          return `https://drive.google.com/file/d/${audioid}/preview`;
        }else{
            return urlfromdb;
        } 
      };

    const extractaudioid=(url)=> {
        const regex = /file\/d\/(.*?)\//;
        const match = url.match(regex);
        const audiofileid = match ? match[1] : null;
        return audiofileid;
      };
   

    return ( 
        <div className="playaudiomessage">
             {erroralert && <div>{erroralert}</div>}
             {ispending &&
            <div style={{
                position:"absolute",
                left:"50%",
                top:"40%"
                }}> 
             <CircularProgress/> <br/>
            loading...
            </div>
            }

            <div className="searchaudiomainpage">
                        <h4 
                        style={{
                        color: "black",
                        fontWeight: "bold" 
                        }}
                        >Audio messages <span style={{color:"orangered"}}>{horemowaudiomessages && horemowaudiomessages.length}</span>
                        </h4> 
                    <input type="search" placeholder="search" onChange={e => setSearchAudio(e.target.value)}/> 
                    
                        <div className="pagetoplogo flex-row2">
                          <h3>HbrSoftTeam</h3>
                        <img src={hbricon} alt=""/>
                        </div>
            </div>

            <div className="searchaudiomainpagephone">
                <h4 
                style={{
                color: "black",
                fontWeight: "bold" 
                }}
                >{horemowaudiomessages && horemowaudiomessages.length}
                </h4>

                <div className="showmorecontent" style={{position:"relative"}} onClick={()=>setShowmore(prev => !prev)}>
                    <h4>More</h4>
                    <svg
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    height="2em"
                    width="2em">
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M7 10l5 5 5-5z" />
                    </svg>

                    {showMore && 
                        <div className="audiodatasubcomp2">
                        {erroralert2 && <div>{erroralert2}</div>}
                        {ispending2 &&
                        <div style={{
                            position:"absolute",
                            left:"50%",
                            top:"50%"
                            }}> 
                        <CircularProgress/> <br/>
                        loading...
                        </div>
                        }
                        {selectedAudio && horemowaudiomessages && horemowaudiomessages.filter((audioData)=>{
                        if(audioData.id === selectedAudio.id){
                            return false;
                        }else if(searchAudio === ""){
                            return true;
                        }else if(audioData.title.toLowerCase().includes(searchAudio.toLowerCase())){
                            return true;
                        }
                            return false;
                        }).map((audioData) => (
                            <AudioListContent
                            key={audioData.id}
                            audioID = {audioData.id}
                            audioTitle = {audioData.title}
                        />
                        ))
                        }
                        </div> 
                    }
                </div>

                {showSearch ? 
                <div className="flex-row2" style={{width:"80%"}}>
                    <input type="search" placeholder="search" onChange={e => setSearchAudio(e.target.value)}/> 
                    <svg
                    onClick={()=>setShowSearch(false)}
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    height="1.5em"
                    width="1.5em">
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                  </svg>
                </div>
         
                    :
                    <svg
                    onClick={()=>setShowSearch(true)}
                    viewBox="0 0 24 24"
                    fill="currentColor"
                    height="1.5em"
                    width="1.5em">
                    <path d="M10 18a7.952 7.952 0 004.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0018 10c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8zm0-14c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z" />
                  </svg>
                }

                {!showSearch && 
                    <div className="pagetoplogo flex-row2">
                         <h4>HBR <span style={{color:"orangered",fontWeight:"bold"}}>LiTE</span></h4> 
                       <img src={hbricon} alt=""/>
                    </div> 
                }
                
            </div>
            
            <div className="audiopayerviewdiv" style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"center"}}>
                <div className="audioplayerViewwrapper">
                    {
                        !ispending && selectedAudio &&
                            <div className="playerView">

                                <div className="audiomsgicon">
                                <img src={audioicon} alt="Streaming from horemow book reader server"/>
                                </div>
                               

                                <iframe id="audiomessageplayerframe" 
                                src={convertUrl(selectedAudio.audioUrl && selectedAudio.audioUrl)} 
                                allow="autoplay"
                                title={selectedAudio.title}
                                >
                                </iframe>

                                <div className="audiomessagetitle flex-column1" style={{gap:"10px"}}>
                                <h4>Playing Now... <span style={{color:"#f1356d"}}>{selectedAudio.title}</span></h4>
                                <p id="clickmoremessage" style={{color:"white",fontWeight:"bold"}}>Click on more button 👆 to show more messages</p>
                                <a href={`https://drive.google.com/uc?export=download&id=${extractaudioid(convertUrl(selectedAudio.audioUrl))}`} 
                                >
                                    Download audio 🎧
                                </a>
                                </div>
                              
                            
                            <svg
                                onClick={()=>shareAudio()}
                                cursor="pointer"
                                id="abplayershare"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                height="2em"
                                width="2em">
                                <path d="M3 12c0 1.654 1.346 3 3 3 .794 0 1.512-.315 2.049-.82l5.991 3.424c-.018.13-.04.26-.04.396 0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3c-.794 0-1.512.315-2.049.82L8.96 12.397c.018-.131.04-.261.04-.397s-.022-.266-.04-.397l5.991-3.423c.537.505 1.255.82 2.049.82 1.654 0 3-1.346 3-3s-1.346-3-3-3-3 1.346-3 3c0 .136.022.266.04.397L8.049 9.82A2.982 2.982 0 006 9c-1.654 0-3 1.346-3 3z" />
                            </svg>
                            </div>
                    }
                </div>
            </div>
          

     
            <div className="audiodatasubcomp">
                 {erroralert2 && <div>{erroralert2}</div>}
                 {ispending2 &&
                 <div style={{
                     position:"absolute",
                     left:"50%",
                     top:"50%"
                     }}> 
                 <CircularProgress/> <br/>
                 loading...
                 </div>
                 }
                 {selectedAudio && horemowaudiomessages && horemowaudiomessages.filter((audioData)=>{
                 if(audioData.id === selectedAudio.id){
                     return false;
                 }else if(searchAudio === ""){
                     return true;
                 }else if(audioData.title.toLowerCase().includes(searchAudio.toLowerCase())){
                     return true;
                 }
                     return false;
                 }).map((audioData) => (
                     <AudioListContent
                     key={audioData.id}
                     audioID = {audioData.id}
                     audioTitle = {audioData.title}
                 />
                 ))
                 }
             </div> 
            
          
        </div>
     );
}
export default PlayAudioMessage;